import PaymentDetail from "../../common/PaymentDetail";

const CasinoPlusSummary = ({ detail }) => {
  return (
    <>
      <PaymentDetail
        title="Casino Plus Mobile Number:"
        value={detail.mobileNumber}
      />
      <PaymentDetail title="Amount:" value={detail.amount} />
    </>
  );
};

export default CasinoPlusSummary;
